import * as React from 'react';
import { FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Toggle, IToggleProps } from '@fluentui/react';

export interface HookFormToggleProps {
  name: string;
  rules?: UseControllerProps['rules'];
  defaultValue?: boolean;
  onToggleChange?: (value: boolean) => void;
  label?: string;
  inlineLabel?: boolean;
}

export const FormHookToggle: FC<HookFormToggleProps & IToggleProps> = ({
  name,
  rules,
  defaultValue = false,
  onToggleChange,
  label,
  inlineLabel = true,
  ...props
}) => {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error },
  } = useController({ name, rules, defaultValue }); 

  return (
    <Toggle
      label={label}
      inlineLabel={inlineLabel}
      checked={!!value}
      onChange={(_, checked) => {
        onChange(checked);
        onToggleChange?.(!!checked);
      }}
      onBlur={onBlur}
      componentRef={ref}
      {...props}
    />
  );
};
